// Modules
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import cx from 'classnames';
import browserHistory from 'react-router/lib/browserHistory';
import { getLang } from 'redux-pagan';
import { connect } from 'react-redux';
import OMTitle from '../../components/OMComponents/OMTitle/OMTitle';
// Components
import OMTabs from '../../components/OMComponents/OMTabs/OMTabs';
import OMTab from '../../components/OMComponents/OMTabs/OMTab';
import withPageWrapper from '../../containers/PageContainer/PageContainer';
// Helpers
import appendLocale from '../../helpers/appendLocale';
import { shareUrl, privacyTermsTabs } from '../../constants';
import multiLanguageTags from '../../helpers/multiLanguageHeadTags';
// Styles
import * as styles from './PrivacyPolicyPage.scss';

class PrivacyPolicyPage extends Component {
  componentDidMount() {
    this.parenthesis.innerHTML = this.props.translate('parenthesis');
  }

  handleSelect = (key) => {
    if (key === privacyTermsTabs.TERMS) {
      browserHistory.push(appendLocale(this.props.locale, `/terms${this.props.isNative ? '?native=true' : ''}`));
    }
  };

  render() {
    const { route, locale } = this.props;
    const multiLanguage = multiLanguageTags(route, locale);
    return (
      <div className={cx(styles.main_block, 'pageHeight')}>
        <div className={cx(styles.content, styles.onlyHe)}>
          <Helmet
            titleTemplate={this.props.staticTranslates('title', 'titleTemplate')()}
            title={`${this.props.staticTranslates('helmet', 'privacyTitle')}`}
            meta={[
              { property: 'og:url', content: `${shareUrl}${route}` },
              {
                property: 'og:title',
                content: `${this.props.staticTranslates('helmet', 'privacyTitle')} | \u202BOnMap`
              },
              { property: 'og:description', content: this.props.staticTranslates('helmet', 'privacyDescription') },
               {
                property: 'x:title',
                content: `${this.props.staticTranslates('helmet', 'privacyTitle')} | \u202BOnMap`
              },
              { property: 'x:description', content: this.props.staticTranslates('helmet', 'privacyDescription') },
              { property: 'x:image:alt', content: this.props.staticTranslates('footer', 'privacy') },
              { name: 'description', content: this.props.staticTranslates('helmet', 'privacyDescription') }
            ]}
            link={[
              ...multiLanguage,
              { rel: 'canonical', href: `${shareUrl}${route}` }
            ]}
          />

          <OMTabs
            defaultActiveTabKey={privacyTermsTabs.PRIVACY}
            onSelect={this.handleSelect}
            id="privacy-policy"
            className="PrivacyTermsTabs"
          >
            <OMTab id={privacyTermsTabs.TERMS} title={`${this.props.staticTranslates('footer', 'terms')}`} />
            <OMTab id={privacyTermsTabs.PRIVACY} title={`${this.props.staticTranslates('footer', 'privacy')}`}>
              {(!this.props.isMobile && !this.props.isNative) && (
                <OMTitle className="pageTitle" title={this.props.staticTranslates('footer', 'privacy')} />
              )}
              <p style={{ textAlign: 'right' }} ref={(parenthesis) => { this.parenthesis = parenthesis; }} />
              <ol>
                <li><strong>{this.props.translate('1')}</strong>
                  <ol>
                    <li>{this.props.translate('1.1')}</li>
                  </ol>
                </li>
                <li><strong>{this.props.translate('2')}</strong>
                  <ol>
                    <li>{this.props.translate('2.1')}</li>
                    <li>{this.props.translate('2.2')}</li>
                    <ol>
                      <li>{this.props.translate('2.2.1')}</li>
                      <li>{this.props.translate('2.2.2')}</li>
                      <li>{this.props.translate('2.2.3')}</li>
                      <li>{this.props.translate('2.2.4')}</li>
                      <li>{this.props.translate('2.2.5')}</li>
                      <li>{this.props.translate('2.2.6')}</li>
                      <li>{this.props.translate('2.2.7')}</li>
                      <li>{this.props.translate('2.2.8')}</li>
                      <li>{this.props.translate('2.2.9')}</li>
                      <li>{this.props.translate('2.2.10')}</li>
                    </ol>
                  </ol>
                </li>
                <li><strong>{this.props.translate('3')}</strong>
                  <ol>
                    <li>{this.props.translate('3.1')}</li>
                    <ol>
                      <li>{this.props.translate('3.1.1')}</li>
                      <li>{this.props.translate('3.1.2')}</li>
                      <li>{this.props.translate('3.1.3')}</li>
                      <li>{this.props.translate('3.1.4')}</li>
                    </ol>
                  </ol>
                </li>
                <li><strong>{this.props.translate('4')}</strong>
                  <ol>
                    <li>{this.props.translate('4.1')}</li>
                  </ol>
                </li>
                <li><strong>{this.props.translate('5')}</strong>
                  <ol>
                    <li>{this.props.translate('5.1')}</li>
                    <li>{this.props.translate('5.2')}</li>
                  </ol>
                </li>
              </ol>
            </OMTab>
          </OMTabs>
        </div>
      </div>
    );
  }
}

PrivacyPolicyPage.propTypes = {
  locale: PropTypes.string.isRequired,
  translate: PropTypes.func.isRequired,
  staticTranslates: PropTypes.func.isRequired,
  route: PropTypes.string.isRequired,
  isMobile: PropTypes.bool,
  isNative: PropTypes.bool
};

const mapStateToProps = state => ({
  translate: getLang(state.lang, 'privacy'),
  staticTranslates: getLang(state.lang, 'static')
});

export default connect(mapStateToProps)(
  withPageWrapper(PrivacyPolicyPage)
);
